import React from 'react';
import { Spinner } from 'react-bootstrap';
import { DUREE_BANDS } from '../utils/constants';
import InfoTip from './InfoTip';

export const dureeColor = (j) => {
  if (j == null) return '#888';
  if (j <= 30)  return '#2e7d32';
  if (j <= 60)  return '#1565c0';
  if (j <= 90)  return '#e65100';
  return '#c62828';
};

const DureeTraitementSection = ({ data, loading, onKpiClick }) => {
  const stats = data?.stats;

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}><Spinner /></div>;
  if (!data)   return <div style={{ padding: 40, textAlign: 'center', color: '#aaa', fontSize: '0.85rem' }}>Aucune donnée</div>;

  const cardStyle = (color) => ({
    background: '#fff', border: `2px solid #e0d6cc`,
    borderRadius: 8, padding: '10px 16px', minWidth: 90, textAlign: 'center',
    cursor: 'pointer', transition: 'all 0.15s',
  });
  const bandStyle = (b) => ({
    background: b.bg, border: `2px solid ${b.color}44`,
    borderRadius: 8, padding: '10px 14px', minWidth: 80, textAlign: 'center',
    cursor: 'pointer', transition: 'all 0.15s',
  });

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {[
            { band: 'all', label: 'Dossiers', info: 'Nombre total de dossiers dont la date de réservation est dans la période sélectionnée.',                       value: stats?.nbDossiers ?? '—', color: '#1e3a5f' },
            { band: 'all', label: 'Moy.',     info: 'Durée moyenne de traitement en jours (réservation → passage notaire ou clôture) sur tous les dossiers.',       value: stats?.avgJours != null ? `${stats.avgJours} j` : '—', color: dureeColor(stats?.avgJours) },
            { band: 'all', label: 'Min.',     info: 'Durée de traitement la plus courte enregistrée sur la période.',                                                value: stats?.minJours != null ? `${stats.minJours} j` : '—', color: '#2e7d32' },
            { band: 'all', label: 'Max.',     info: 'Durée de traitement la plus longue — dossier le plus lent sur la période. Cliquez pour voir le détail.',       value: stats?.maxJours != null ? `${stats.maxJours} j` : '—', color: '#c62828' },
          ].map(({ band, label, info, value, color }) => (
            <div key={label} onClick={() => onKpiClick({ band, label: `Durée traitement — Tous (${label})` })} style={cardStyle(color)}>
              <div style={{ fontSize: '0.62rem', color: '#aaa', fontWeight: 700, textTransform: 'uppercase', marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                {label}<InfoTip text={info} />
              </div>
              <div style={{ fontSize: '1.2rem', fontWeight: 800, color }}>{value}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'stretch' }}>
          {DUREE_BANDS.map(b => (
            <div key={b.key} onClick={() => onKpiClick({ band: b.key, label: `Durée traitement — ${b.label}` })} style={bandStyle(b)}>
              <div style={{ fontSize: '0.62rem', color: b.color, fontWeight: 700, marginBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                {b.label}<InfoTip text={b.info} />
              </div>
              <div style={{ fontSize: '1.1rem', fontWeight: 800, color: b.color }}>{stats?.[b.key] ?? 0}</div>
            </div>
          ))}
        </div>

        {stats?.maxJours > 0 && (
          <div style={{ flex: 1, minWidth: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 8px' }}>
            <div style={{ fontSize: '0.65rem', color: '#aaa', marginBottom: 4 }}>Distribution durée (0 → {stats.maxJours} j)</div>
            <div style={{ height: 10, background: '#f0ebe4', borderRadius: 5, overflow: 'hidden', display: 'flex' }}>
              {DUREE_BANDS.map((b, i) => {
                const counts = [stats.nb30j, stats.nb60j, stats.nb90j, stats.nbSup90j];
                const pct = stats.nbDossiers > 0 ? (counts[i] / stats.nbDossiers) * 100 : 0;
                return pct > 0 ? <div key={b.key} style={{ width: `${pct}%`, background: b.color, transition: 'width 0.4s' }} title={`${b.label} : ${counts[i]} dossier(s)`} /> : null;
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DureeTraitementSection;
